import {EduTreeCourse, EduTreeLesson, EduTreeSection} from "protocol/edutrading/GetEducationalContentTree";

export class EduTradingReportsUtil {

    public static FormatCourseInfo = (course: EduTreeCourse): string => {
        return `course name ${course?.Title}, course id ${course?.Id}`;
    }

    public static FormatLessonVideoEnd = (course: EduTreeCourse, lesson: EduTreeLesson): string => {
        let section: EduTreeSection;
        for (let i: number = 0; i < course?.Sections.length; i++) {
            if (course.Sections[i].Lessons.filter((l: EduTreeLesson) => l.LessonGuid === lesson.LessonGuid)[0]) {
                section = course.Sections[i];
                break;
            }
        }
        return `video_name ${lesson?.Title}, video_id ${lesson?.LessonGuid}, category_name ${section?.Title}, category_id ${section?.Id}, course_name ${course?.Title}, course_id ${course?.Id}`;
    }

    public static FormatLessonCompletedInfo = (course: EduTreeCourse, lesson: EduTreeLesson): object => {
        return {
            video: {
                name: lesson?.Title,
                id: lesson?.LessonGuid
            },
            course: {
                name: course?.Title,
                id: course?.Id
            }
        };
    }
}
